module.exports = __webpack_public_path__ + "static/media/edit.1cdebcb5.svg";